import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/g;
// A sentence-ending "." or a wrapping ")"/'"' right after a URL almost never
// belongs to the URL itself (e.g. "check this out: https://x.com/foo.") -
// trimmed off the link and re-appended as plain text instead.
const TRAILING_PUNCT = /[.,!?;:)'"]+$/;

// target="_blank" here is what electron-starter.js's setWindowOpenHandler
// intercepts to open in the OS's real browser instead of another Electron
// window - in the plain web build it's just a normal new tab, no extra
// handling needed there.
export function linkify(text) {
    return String(text).split(URL_REGEX).map((part, i) => {
        if (i % 2 === 0) return part; // plain text between/around matches
        const trailingMatch = part.match(TRAILING_PUNCT);
        const trailing = trailingMatch ? trailingMatch[0] : '';
        const url = trailing ? part.slice(0, -trailing.length) : part;
        const href = url.startsWith('http') ? url : `https://${url}`;
        return (
            <React.Fragment key={i}>
                <a href={href} target="_blank" rel="noopener noreferrer">{url}</a>
                {trailing}
            </React.Fragment>
        );
    });
}
